export default __webpack_public_path__ + "6aab0c6.png";